const DESKTOP_BREAKPOINT = 1024;

const isDesktopViewport = () => window.innerWidth >= DESKTOP_BREAKPOINT;

export const createPaneLayoutResizer = ({
  container,
  sidebarHandle,
  detailsHandle,
  state,
}) => {
  let activeType = null;
  let activeHandle = null;
  let rafId = null;

  const setDragging = (isDragging) => {
    if (activeHandle) {
      activeHandle.classList.toggle('is-dragging', isDragging);
    }

    if (container) {
      container.classList.toggle('is-resizing-panes', isDragging);
    }

    document.body.classList.toggle('is-resizing-panes', isDragging);
  };

  const onPointerMove = (event) => {
    if (!activeType || !container) {
      return;
    }

    event.preventDefault();
    const clientX = Number(event.clientX);
    if (!Number.isFinite(clientX)) {
      return;
    }

    if (rafId) {
      window.cancelAnimationFrame(rafId);
    }

    rafId = window.requestAnimationFrame(() => {
      const rect = container.getBoundingClientRect();
      if (activeType === 'sidebar') {
        state.updateSidebar(clientX - rect.left);
        return;
      }

      state.updateDetails(rect.right - clientX);
    });
  };

  const stopDrag = () => {
    if (!activeType) {
      return;
    }

    if (rafId) {
      window.cancelAnimationFrame(rafId);
      rafId = null;
    }

    window.removeEventListener('pointermove', onPointerMove);
    window.removeEventListener('pointerup', stopDrag);
    window.removeEventListener('pointercancel', stopDrag);

    setDragging(false);
    activeType = null;
    activeHandle = null;
    state.persistCurrent();
  };

  const startDrag = (type, handle, event) => {
    if (!isDesktopViewport() || event.button !== 0) {
      return;
    }

    event.preventDefault();
    activeType = type;
    activeHandle = handle;
    setDragging(true);

    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', stopDrag);
    window.addEventListener('pointercancel', stopDrag);
  };

  const onSidebarPointerDown = (event) => {
    startDrag('sidebar', sidebarHandle, event);
  };

  const onDetailsPointerDown = (event) => {
    startDrag('details', detailsHandle, event);
  };

  const onWindowResize = () => {
    if (isDesktopViewport()) {
      state.syncToViewport();
      return;
    }

    stopDrag();
    state.clearLayoutVariables();
  };

  const init = () => {
    if (!container || !sidebarHandle || !detailsHandle) {
      return () => {};
    }

    sidebarHandle.addEventListener('pointerdown', onSidebarPointerDown);
    detailsHandle.addEventListener('pointerdown', onDetailsPointerDown);
    window.addEventListener('resize', onWindowResize);

    if (isDesktopViewport()) {
      state.loadInitialLayout();
    } else {
      state.clearLayoutVariables();
    }

    return () => {
      stopDrag();
      sidebarHandle.removeEventListener('pointerdown', onSidebarPointerDown);
      detailsHandle.removeEventListener('pointerdown', onDetailsPointerDown);
      window.removeEventListener('resize', onWindowResize);
      setDragging(false);
    };
  };

  return {
    init,
  };
};
